import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-requestloanpage',
  templateUrl: './requestloanpage.component.html',
  styleUrls: ['./requestloanpage.component.css']
})
export class RequestloanpageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
